import React from "react";

export default function DashboardHeader({
  logoSrc,
  logoAlt,
  logoClassName = "",
  logo,
  actions,
}) {
  return (
    <div className="containerFlex">
      <div className="card flexBetween printHeader">
        {logo || <img className={logoClassName} src={logoSrc} alt={logoAlt} />}
        <div>{actions}</div>
      </div>
    </div>
  );
}
